/**
 * 디버그 API 생성
 */
export function createDebugAPI(core) {
    return {
        getHistory() {
            const history = core.getHistory();
            return history ? history.getAll() : [];
        },
        getActions() {
            return core.getRegisteredActions();
        },
        getSystems() {
            return core.getRegisteredSystems();
        },
        dumpState() {
            return JSON.stringify(core.getState(), null, 2);
        },
        simulate(action) {
            // 현재 상태를 복사하여 시뮬레이션
            const result = core.dispatch(action);
            // 원래 상태로 복원 (실제로는 이미 변경됨)
            // 주의: 이 방식은 실제 상태를 변경하므로 개선 필요
            // 현재는 단순화를 위해 실제 dispatch 결과를 반환
            return {
                wouldChange: result.stateChanged,
                error: result.error
            };
        }
    };
}
/**
 * 콘솔에 상태 트리 출력 (디버깅용)
 */
export function printStateTree(state, depth = 2) {
    const print = (obj, indent = 0, currentDepth = 0) => {
        if (currentDepth >= depth) {
            console.log(' '.repeat(indent) + '...');
            return;
        }
        if (obj === null) {
            console.log(' '.repeat(indent) + 'null');
            return;
        }
        if (typeof obj !== 'object') {
            console.log(' '.repeat(indent) + String(obj));
            return;
        }
        if (Array.isArray(obj)) {
            console.log(' '.repeat(indent) + `Array(${obj.length})`);
            obj.slice(0, 5).forEach((item, i) => {
                console.log(' '.repeat(indent + 2) + `[${i}]:`);
                print(item, indent + 4, currentDepth + 1);
            });
            if (obj.length > 5) {
                console.log(' '.repeat(indent + 2) + `... (${obj.length - 5} more)`);
            }
            return;
        }
        for (const [key, value] of Object.entries(obj)) {
            console.log(' '.repeat(indent) + `${key}:`);
            print(value, indent + 2, currentDepth + 1);
        }
    };
    console.log('=== State Tree ===');
    print(state);
    console.log('==================');
}
//# sourceMappingURL=debug.js.map